import {
    convertCurrencyFormatPositiveNegative, convertPersianDateToUniversalDate,
    convertUniversalDateToPersianDate,
    RaikoBaseCardContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoCustomSimpleChip,
    RaikoCustomTable,
    RaikoDatePicker, RaikoDivider,
    RaikoGridFourColumn,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    showErrorMessage, showWarningMessage,
    RaikoTableTitleContainer,
    RaikoChipTypes
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useRef, useState} from "react";
import useDraggableScroll from "use-draggable-scroll";
import PointsStatistics from "../../raicheComponents/statistics/PointsStatistics";
import {css} from "@emotion/css";
import {useDebounce} from "@uidotdev/usehooks";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {useAuthState} from "../../context/AuthContext";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {RouteHelper} from "../../route/RouteHelper";

export default function GroupReports() {

    const ref = useRef(null);
    const {onMouseDown} = useDraggableScroll(ref, {direction: 'horizontal'});

    const service = new GroupsService()
    const {fundID} = useAuthState()

    const [reports, setReports] = useState({
        numberOfLoans: 0,
        summationOfDepositAccountsBalance: 0,
        summationOfLoans: 0,
        summationOfPaidInstallment: 0
    });

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [groupName, setGroupName] = useState("");
    const [groupCode, setGroupCode] = useState("");

    const startDateFilter = useDebounce(startDate, 300)
    const endDateFilter = useDebounce(endDate, 300)
    const groupNameFilter = useDebounce(groupName, 300)
    const groupCodeFilter = useDebounce(groupCode, 300)

    const [page, setPage] = useState(0);
    const size = 15

    const [tableData, setTableData] = useState([])
    const [pageCount, setPageCount] = useState(0)
    const [numberOfItems, setNumberOfItems] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);


    useEffect(() => {
        if (startDateFilter && endDateFilter && startDateFilter.length === 10 && endDateFilter.length === 10) {
            getDataFromServer()
            getSummationData()
        }
    }, [
        startDateFilter,
        endDateFilter,
        groupNameFilter,
        groupCodeFilter,
        fundID,
        page
    ]);

    function getSummationData() {
        service.getGroupReportSummation(
            fundID,
            startDate,
            endDate,
            groupName,
            groupCode
        ).then(response => {
            setReports(response)
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {

        })
    }

    function getDataFromServer() {
        setTableLoadingState(true)
        service.getGroupReportsByFilters(
            fundID,
            page,
            size,
            startDate,
            endDate,
            groupName,
            groupCode,
        ).then(response => {
            setNumberOfItems(response.numberOfItems)
            setPageCount(response.totalPage)
            setTableData([])
            response.data.map((item, index) => {
                setTableData(prevState => [...prevState, {
                    ...item,
                    number: (page * 15) + index + 1,
                    createdDate: convertUniversalDateToPersianDate(item.createdAt),
                    numberOfLoans: convertCurrencyFormatPositiveNegative(item.numberOfLoans),
                    cash: convertCurrencyFormatPositiveNegative(item.summationOfDepositAccountsBalance),
                    cashNewAccounts: convertCurrencyFormatPositiveNegative(item.numberOfOpenedDepositAccount),
                    cashExitAccounts: convertCurrencyFormatPositiveNegative(item.numberOfClearedDepositAccount),
                    summationOfLoans: convertCurrencyFormatPositiveNegative(item.summationOfLoans),
                    loanAmount: convertCurrencyFormatPositiveNegative(item.summationOfPaidInstallment),
                    state: item.enabled ?
                        <RaikoCustomSimpleChip
                            title={"فعال"}
                            type={RaikoChipTypes.success}
                        />
                        :
                        <RaikoCustomSimpleChip
                            title={"غیر فعال"}
                            type={RaikoChipTypes.error}
                        />,
                }])
            })

        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoadingState(false)
        })

    }

    function handleChangePage(newPage) {
        setPage(newPage)
    }


    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
            <RaikoBreadcrumb breadCrumbItems={[
                raikoBreadCrumbItemGenerator(
                    RouteHelper.GroupsReport.name,
                    RouteHelper.GroupsReport.globalUrl
                )
            ]}/>
            <div className="statisticsLayout hideScroll" ref={ref} onMouseDown={onMouseDown}>

                <PointsStatistics
                    title={"تعداد وام ها"}
                    amount={reports.numberOfLoans}
                />

                <PointsStatistics
                    title={"مجموع پس انداز (ریال)"}
                    amount={reports.summationOfDepositAccountsBalance}
                />

                <PointsStatistics
                    title={"مجموع وام ها"}
                    amount={reports.summationOfLoans}
                />

                <PointsStatistics
                    title={"مجموع اقساط پرداخت شده"}
                    amount={reports.summationOfPaidInstallment}
                />
            </div>

            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"گزارش گیری"}
                    subTitle={"لطفا ابتدا بازه ی زمانی مورد نظر خود را انتخاب نمایید."}
                >
                    <RaikoGridOneColumn>
                        <RaikoGridFourColumn className={css`align-items: end`}>
                            <RaikoDatePicker
                                label={"تاریخ شروع"}
                                date={startDate}
                                setDate={newDate => {
                                    setStartDate(newDate)

                                    if (Date.parse(convertPersianDateToUniversalDate(newDate)) <= Date.parse(convertPersianDateToUniversalDate(endDate))
                                        || !endDate || endDate.length === 0
                                    ) {
                                        setStartDate(newDate)
                                    } else
                                        showWarningMessage("تاریخ شروع بازه می بایست کوچکتر از تاریخ پایان باشد")
                                }}
                            />

                            <RaikoDatePicker
                                label={"تاریخ پایان"}
                                date={endDate}
                                setDate={newDate => {
                                    setEndDate(newDate)

                                    if (Date.parse(convertPersianDateToUniversalDate(newDate)) >= Date.parse(convertPersianDateToUniversalDate(startDate))
                                        || !startDate || startDate.length === 0
                                    ) {
                                        setEndDate(newDate)
                                    } else
                                        showWarningMessage("تاریخ پایان بازه می بایست بزرگتر از تاریخ شروع باشد")
                                }}
                            />

                            <RaikoMaterialOutlinedInput
                                labelText={"نام گروه"}
                                value={groupName}
                                setValue={setGroupName}
                            />

                            <RaikoNumberInputOutlined
                                labelText={"کد گروه"}
                                value={groupCode}
                                setValue={setGroupCode}
                            />
                        </RaikoGridFourColumn>


                        <RaikoTableTitleContainer
                            title={"گروه ها"}
                            amount={numberOfItems}
                        />

                        <RaikoCustomTable
                            header={header} data={tableData} isLoading={tableLoadingState}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePage}/>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
        </RaikoGridOneColumn>
    )
}

const header = [
    {
        id: 'number',
        label: '#',
        align: 'right',
    },
    {
        id: 'name',
        label: 'نام',
        align: 'right',
    },
    {
        id: 'code',
        label: 'کد گروه',
        align: 'right',
    },
    {
        id: 'cash',
        label: 'مجموع پس انداز (ریال)',
        align: 'right',
    },
    {
        id: 'cashNewAccounts',
        label: 'حساب جدید',
        align: 'right',
    },
    {
        id: 'cashExitAccounts',
        label: 'حساب بسته شده',
        align: 'right',
    },
    {
        id: 'numberOfLoans',
        label: 'تعداد وام ها',
        align: 'right',
    },
    {
        id: 'summationOfLoans',
        label: 'مجموع وام ها',
        align: 'right',
    },
    {
        id: 'loanAmount',
        label: 'مجموع اقساط پرداخت شده (ریال)',
        align: 'right',
    },
    {
        id: 'createdDate',
        label: 'تاریخ ساخت',
        align: 'right',
    },
    {
        id: 'state',
        label: 'وضعیت',
        align: 'right',
    },
]